import React from "react";

const loaderStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  background: "#fff",
};

const spinnerStyle: React.CSSProperties = {
  border: "8px solid #f3f3f3",
  borderTop: "8px solid #2c3e50",
  borderRadius: "50%",
  width: "80px",
  height: "80px",
  animation: "spin 1s linear infinite",
  marginBottom: "2rem",
};

const textStyle: React.CSSProperties = {
  color: "#2c3e50",
  fontSize: "1.5rem",
  fontWeight: "bold",
  letterSpacing: "1px",
};

export default function PrettyLoader() {
  return (
    <div style={loaderStyle}>
      <div style={spinnerStyle} />
      <div style={textStyle}>Cargando, por favor espere...</div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg);}
            100% { transform: rotate(360deg);}
          }
        `}
      </style>
    </div>
  );
}